import React from 'react'

export const Supplementarymaterialforinstructor = () => {
  return (
    <div></div>
  )
}
